import { IExportColumnModel } from "../../../../../../shared/models";

export const ScopeFieldSchemaChangesColumnList: IExportColumnModel[] = [
]